import { render, staticRenderFns } from "./InvitationinRequestReceived.vue?vue&type=template&id=45ddc179&scoped=true&"
import script from "./InvitationinRequestReceived.vue?vue&type=script&lang=js&"
export * from "./InvitationinRequestReceived.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/simplePage.css?vue&type=style&index=0&id=45ddc179&prod&scoped=true&lang=css&"
import style1 from "./InvitationinRequestReceived.vue?vue&type=style&index=1&id=45ddc179&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ddc179",
  null
  
)

export default component.exports